import script from "./TwoFactorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoFactorView.vue?vue&type=script&setup=true&lang=ts"

import "./TwoFactorView.vue?vue&type=style&index=0&id=614c82c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-614c82c0"]])

export default __exports__